// Copyright (c) 2018 Deere & Company

import CourierInfo, {getDefaultState as getDefaultCourierInfoState} from '@deere/cps-it.warranty-model-factory/lib/courier-info';
import ReturnStatus, {getDefaultState as getDefaultReturnStatusState} from '@deere/cps-it.warranty-model-factory/lib/return-status';
import t from 'tcomb';

const PartRequestForm = t.struct({
    courierInfo: CourierInfo,
    dispatchDate: t.maybe(t.Number),
    returnStatus: ReturnStatus
}, 'PartRequestForm');

export const getDefaultState = () => new PartRequestForm({
    courierInfo: getDefaultCourierInfoState(),
    dispatchDate: null,
    returnStatus: getDefaultReturnStatusState()
});

export default PartRequestForm;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/state/part-request-form.js